import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  MenuItem,
  CircularProgress,
} from "@mui/material";
import axios from "../../../utils/axiosInstance";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getUIDescription } from "../customerGroupDetails/AssigningCustomerGroupDevice";
export default function AddTechnicianForm({
  open,
  onClose,
  onAddTechnician,
  group,
  regionRefresher,
}) {
  const [routeName, setRouteName] = useState("");
  const [notes, setNotes] = useState("");
  const [groupName, setGroupName] = useState(group.name);
  const [regionDistrict, setRegionDistrict] = useState("");
  const [errors, setErrors] = useState({});
  const [allRegions, setAllRegions] = useState([]);
  const [loadingRegions, setLoadingRegions] = useState(false);
  const [loading, setLoading] = useState(false); // 🔹 Loading for submission

  useEffect(() => {
    const fetchRegions = async () => {
      try {
        setLoadingRegions(true);
        const response = await axios.get(
          `${process.env.REACT_APP_API_GATEAWAY}/regions?groupId=${group.id}`,
          {
            params: { companyId: process.env.REACT_APP_COMPANY_ID },
          }
        );
        setAllRegions(response.data);
      } catch (err) {
        console.error("❌ Error fetching regions:", err);
        setAllRegions([]);
      } finally {
        setLoadingRegions(false);
      }
    };

    fetchRegions();
  }, [groupName, regionRefresher]);

  const validateForm = () => {
    const newErrors = {};

    if (!routeName.trim()) newErrors.routeName = "Technician Name is required";
    if (!groupName) newErrors.groupName = "Group Name is required";
    if (!notes.trim()) newErrors.notes = "Notes are required";
    if (!regionDistrict.trim()) newErrors.region = "Region is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleAddTechnician = async () => {
    if (!validateForm()) return;

    setLoading(true); // 🔹 Start loading
    try {
      const payload = {
        companyId: process.env.REACT_APP_COMPANY_ID,
        name: routeName,
        description: notes,
        groupId: group.id,
        regionId: regionDistrict,
        UI_Description: `${getUIDescription()}\n Add Technician (Route)`, 
      };

      const response = await axios.post(
        `${process.env.REACT_APP_API_GATEAWAY}/routes/`,
        payload
      );

      if (onAddTechnician) onAddTechnician(response.data);
      console.log("✅ Technician created:", response.data);
      toast.success("✅ Technician created successfully!");
      onClose();
      resetForm();
    } catch (error) {
      console.error(
        "❌ Error creating technician:",
        error.response?.data || error.message
      );
      toast.error(error.response?.data?.message || "❌ Failed to create technician");

    } finally {
      setLoading(false); // 🔹 Stop loading

    }
  };

  const handleFieldChange = (field, value, setter) => {
    setter(value);
    if (errors[field]) {
      setErrors((prev) => ({ ...prev, [field]: undefined }));
    }
  };

  const resetForm = () => {
    setRouteName("");
    setNotes("");
    setRegionDistrict("");
    setErrors({});
  };

  const handleCancel = () => {
    resetForm();
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Add New Technician</DialogTitle>
      <DialogContent dividers>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}>
          <TextField
           sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: 0, // ✅ remove rounding
              },
            }}
            label="Technician Name"
            required
            value={routeName}
            onChange={(e) =>
              handleFieldChange("routeName", e.target.value, setRouteName)
            }
            fullWidth
            error={!!errors.routeName}
            helperText={errors.routeName}
            disabled={loading}
          />

          <TextField
           sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: 0, // ✅ remove rounding
              },
            }}
            label="Notes"
            required
            value={notes}
            onChange={(e) => handleFieldChange("notes", e.target.value, setNotes)}
            fullWidth
            error={!!errors.notes}
            helperText={errors.notes}
            disabled={loading}
          />

          <TextField
           sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: 0, // ✅ remove rounding
              },
            }}
            label="Group Name"
            required
            disabled
            value={groupName}
            fullWidth
            error={!!errors.groupName}
            helperText={errors.groupName}
          />

          <TextField
           sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: 0, // ✅ remove rounding
              },
            }}
            select
            label="Region"
            required
            value={regionDistrict}
            onChange={(e) => setRegionDistrict(e.target.value)}
            fullWidth
            disabled={loading || loadingRegions}
            error={!!errors.region}
            helperText={errors.region}
          >
            {loadingRegions ? (
              <MenuItem disabled>Loading regions...</MenuItem>
            ) : allRegions.length > 0 ? (
              allRegions.map((regionItem) => (
                <MenuItem key={regionItem.id} value={regionItem.id}>
                  {regionItem.name}
                </MenuItem>
              ))
            ) : (
              <MenuItem disabled>No regions available</MenuItem>
            )}
          </TextField>
        </Box>
      </DialogContent>

      <DialogActions>
        <Button onClick={handleCancel} color="error" disabled={loading}>
          Cancel
        </Button>
        <Button
        
             sx={{
                borderRadius: 0, // ✅ remove rounding
            }}
          onClick={handleAddTechnician}
          variant="contained"
          color="primary"
          disabled={
            loading || !routeName || !groupName || !notes || !regionDistrict
          }
        >
          {loading ? (
            <>
              <CircularProgress size={22} color="inherit" sx={{ mr: 1 }} />
              Adding...
            </>
          ) : (
            "Add Technician"
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
